export enum DOCUMENTS_REDUCER_CASE {
  INIT = 'INITIALIZATION',
  INIT_MOBILE = 'INITIALIZATION_MOBILE',
  INIT_PAST_YEARS = 'INITIALIZATION_PAST_YEARS',
  FILTER = 'FILTER',
}
